module.exports = __webpack_public_path__ + "img/artikel.374cc633.png";